<template>
	<transition name="fade">
		<video playsinline autoplay muted loop preload="auto" ref="video" v-show="videoLoaded">
			<source :src="getUrl('dash')" type="application/dash+xml" />
			<source :src="getUrl('hls')" type="application/x-mpegurl" />
			<source :src="getUrl('mp4')" type="video/mp4" />
		</video>
	</transition>
</template>

<script>

	import $ from 'jquery'

	const fileExtensionMap = {
		dash: 'mpd',
		hls: 'm3u8',
		mp4: 'mp4'
	}

	export default {
		name: 'videoServerBackgroundVideo',
		props: {
			src: {
				type: String,
				required: true
			}
		},
		data () {
			return {
				player: null,
				videoLoaded: false
			}
		},
		methods: {
			getUrl (type) {
				const parts = this.src.split('/')
				const file = parts.pop()
				const folder = parts.join('/')
				return `https://video-server.studysync.com/gen/${folder}/${(type === 'cc') ? 'mp4' : type}/${file}.${fileExtensionMap[type]}`
			}
		},
		mounted () {
			const video = this.$refs.video
			$(video).one("loadeddata", () => {
				this.videoLoaded = true
				video.play()
				this.$emit('loadeddata')
			})
		}
	}

</script>

<style lang="scss" scoped>

	.fade {
		&-enter-active,
		&-leave-active {
			transition: opacity 1s;
		}
		&-enter, &-leave-to {
			opacity: 0;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/VideoServerBackgroundVideo.vue